export default {
  text: 'Al usar este sitio web aceptas nuestra',
  cookie_policy: 'Política de cookies.',
  buttons: {
    accept: 'Aceptar',
    reject: 'Rechazar',
  },
};
